<template>
  <section>
    <!--工具条-->
    <el-form :inline="true" class="toolbar" :model="searchForm">
      <el-form-item label="商户">
        <el-select
          clearable
          v-model="searchForm.merchantId"
          filterable
          placeholder="请选择或输入商户名称">
          <el-option
            v-for="item in merchantList"
            :key="item.id"
            :label="item.merchantName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道标签">
        <el-select
          clearable
          v-model="searchForm.channelLabel"
          filterable
          placeholder="请选择或输入渠道名称">
          <el-option
            v-for="item in channelLabelList"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="最近 x 分钟">
        <el-input
          v-model="searchForm.minNun"
          size="mini"
          clearable
          style="width: 120px"
          @input="changeminNum">
        </el-input>
      </el-form-item>
      <el-form-item label="订单时间">
        <el-date-picker
          v-model="searchForm.searchDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleDateChange"
          size="mini" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary" size="mini">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      height="650"
      style="width: 100%"
      v-loading="loading"
      :row-style="rowStyle"
    >
      <el-table-column
        align="center"
        prop="dt"
        label="日期"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="message"
        label="金额区间"
      ></el-table-column>
      <el-table-column align="center" prop="a1" label="100-299" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a3" label="300-599" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a6" label="600-999" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a10" label="1000-1499" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a15" label="1500-1999" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a20" label="2000-4999" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a50" label="5000-9999" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a100" label="10000-19999" :formatter="formatPercent"/>
      <el-table-column align="center" prop="a200" label="20000 +" :formatter="formatPercent"/>
    </el-table>
    <el-pagination
      class="pager"
      @size-change="pageSizeChange"
      @current-change="pageIndexChange"
      :current-page="pageIndex"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="dataTotal"
    ></el-pagination>
  </section>
</template>

<script>
import api from "../../api/merchantPayConfig/PayInAmtRate";
import merchantApi from "@/api/merchantPayConfig/merchantApi";
import DataUtil from "../../utils/config/dataUtil";
import Enum from "../../utils/Enum/Enum";
import {getChannelLabelListApi} from "../../api/report";

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 30,
      dataTotal: 0,
      loading: false,
      tableData: [],
      merchantList: [],
      channelLabelList: [],
      statusList: Enum.orderStatus,
      searchForm: {
        minNun: 5,
        merchantId: "",
        searchDate: [],
        channelLabel: "",
      },
    };
  },
  created() {
    this.getChannelLabelList(1);
    this.merchantSelect();
    this.getList();
  },
  mounted() {},
  methods: {
    getList() {
      this.loading = true;

      if (this.searchForm.searchDate && this.searchForm.searchDate.length === 2) {
        const startDate = new Date(this.searchForm.searchDate[0]);
        const endDate = new Date(this.searchForm.searchDate[1]);

        // 计算天数差
        const timeDiff = endDate.getTime() - startDate.getTime();
        const dayDiff = timeDiff / (1000 * 3600 * 24);
        if (dayDiff > 6) {
          this.$message.error("查看时间段，请不要超过5天！");
          return;
        }
      }
      if (!this.searchForm.minNun && !this.searchForm.searchDate){
        this.searchForm.minNun = 5;
      }
      api.amtRate({
        content: {
          minute: this.searchForm.minNun,
          merchantId: this.searchForm.merchantId,
          searchDate: this.searchForm.searchDate,
          channelLabel: this.searchForm.channelLabel,
        },
      }).then((res) => {
        if (res.code === "0000") {
          this.loading = false;
          this.tableData = res.data;
        }
      });
    },

    merchantSelect() {
      merchantApi.getMerchant({}).then((res) => {
        if (res.code == "0000") {
          this.merchantList = res.data.rows;
        }
      });
    },

    changeminNum(value) {
      if (this.searchForm.minNun > 24 * 60) {
        this.searchForm.minNun = 24 * 60;
        this.$message.warning("查询时间不能超过1天");
      }
      if (value) {
        this.searchForm.searchDate = "";
      }
    },
    handleDateChange(value) {
      if (value && value.length > 0) {
        this.searchForm.minNun = "";
      }
    },

    dateTransform(date) {
      return DataUtil.dateTransform(date);
    },
    getOrderStatus(val) {
      return Enum.getOrderStatus(val);
    },
    search() {
      this.pageIndex = 1;
      this.getList();
    },

    // 分页
    pageSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;

      // this.bindGrid();
    },
    pageIndexChange(val) {
      this.pageIndex = val;

      // this.bindGrid();
    },
    rowStyle({ row }) {
      if (row.message === "成功率 %") {
        return {
          backgroundColor: "#d4bc6f",
        };
      }
      return {};
    },
    formatPercent(row, column, cellValue) {
      if (row.message === "成功率 %") {
        return cellValue !== null && cellValue !== undefined ? cellValue + " %" : "";
      }
      return cellValue;
    },
    async getChannelLabelList(value) {
      let _data = {};
      let content = Object.assign(
        {},
        {
          payType: value,
        }
      );
      _data.content = content;
      let res = await getChannelLabelListApi(_data);
      if (res.code == "0000") {
        this.channelLabelList = res.data;
      }
    },
  },
  components: {},
};
</script>

<style lang="scss">
@import "../../assets/css/base";
.el-form-item {
  margin-bottom: 10px;
}
</style>
